import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { useAuth } from '@/hooks/useAuth'
import { useUpdateProfile } from '@/hooks/useProfile'

const C = { teal: '#0F5C5C', border: '#E1E5E3', ink: '#202523', ink2: '#6D7471' }
const FH = "'Plus Jakarta Sans', sans-serif"
const FB = "'Inter', sans-serif"

const fieldStyle: React.CSSProperties = { marginBottom: 16 }
const labelStyle: React.CSSProperties = {
  display: 'block',
  fontSize: 13,
  fontWeight: 700,
  color: C.ink2,
  marginBottom: 6,
}
const inputStyle: React.CSSProperties = {
  width: '100%',
  border: `1px solid ${C.border}`,
  borderRadius: 11,
  padding: '12px 14px',
  fontFamily: FB,
  fontSize: 14,
  color: C.ink,
  outline: 'none',
}

export default function SettingsPage() {
  const navigate = useNavigate()
  const { profile } = useAuth()
  const updateProfile = useUpdateProfile()

  const [username, setUsername] = useState(profile?.username ?? '')
  const [bio, setBio] = useState(profile?.bio ?? '')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    updateProfile.mutate({ username: username.trim(), bio: bio.trim() })
  }

  return (
    <div style={{ maxWidth: 520, margin: '0 auto', padding: '28px 28px 60px' }}>
      <button
        onClick={() => navigate('/profile')}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          color: C.ink2,
          fontFamily: FB,
          fontSize: 13.5,
          marginBottom: 18,
          padding: 0,
        }}
      >
        <ArrowLeft size={16} /> Volver al perfil
      </button>

      <div
        style={{
          fontFamily: FH,
          fontWeight: 800,
          fontSize: 24,
          letterSpacing: '-0.01em',
          marginBottom: 22,
        }}
      >
        Configuración
      </div>

      <form onSubmit={handleSubmit}>
        <div style={fieldStyle}>
          <label style={labelStyle}>Nombre de usuario</label>
          <input
            style={inputStyle}
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            minLength={2}
            maxLength={30}
            required
          />
        </div>

        <div style={fieldStyle}>
          <label style={labelStyle}>Bio</label>
          <textarea
            style={{ ...inputStyle, resize: 'none' }}
            rows={4}
            value={bio}
            onChange={(e) => setBio(e.target.value)}
            maxLength={300}
            placeholder="Contale a los demás un poco sobre vos"
          />
        </div>

        <button
          type="submit"
          disabled={updateProfile.isPending}
          style={{
            width: '100%',
            padding: 13,
            borderRadius: 12,
            border: 'none',
            background: C.teal,
            color: '#fff',
            fontFamily: FH,
            fontWeight: 700,
            fontSize: 14,
            cursor: updateProfile.isPending ? 'not-allowed' : 'pointer',
            opacity: updateProfile.isPending ? 0.7 : 1,
          }}
        >
          {updateProfile.isPending ? 'Guardando…' : 'Guardar cambios'}
        </button>
      </form>
    </div>
  )
}
